import { render, staticRenderFns } from "./ProductActiveFilters.vue?vue&type=template&id=1172efbf"
import script from "./ProductActiveFilters.vue?vue&type=script&lang=js"
export * from "./ProductActiveFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductActiveFilters.vue?vue&type=style&index=0&id=1172efbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports